module.exports = __webpack_public_path__ + "img/img45s.696122aa.png";